export const BUS_AIRCRAFT_CODE = 'BUS';

export const GENDER_OPTIONS = ['mr', 'ms'];
